import React, { createContext, useContext, useEffect, useState } from 'react';

const OutageContext = createContext({
  active: false,
  until: null,
  reason: null,
  start: () => {},
  stop: () => {}
});

export function OutageProvider({ children }) {
  const [state, setState] = useState({ active: false, until: null, reason: null });

  useEffect(() => {
    const on = (e) => setState({
      active: true,
      until: e.detail?.until || null,
      reason: e.detail?.reason || null
    });
    const off = () => setState({ active: false, until: null, reason: null });

    window.addEventListener('app:outage', on);
    window.addEventListener('app:outage:off', off);
    return () => {
      window.removeEventListener('app:outage', on);
      window.removeEventListener('app:outage:off', off);
    };
  }, []);

  const start = (d) => window.dispatchEvent(new CustomEvent('app:outage', { detail: d || {} }));
  const stop  = () => window.dispatchEvent(new Event('app:outage:off'));

  return (
    <OutageContext.Provider value={{ ...state, start, stop }}>
      {children}
    </OutageContext.Provider>
  );
}

export const useOutage = () => useContext(OutageContext);
